module.exports = __webpack_public_path__ + "img/pythonbox1pic3.62c54f8e.png";